import { useEffect, useRef, useState } from 'react'
import { useLocation } from '@reach/router'
import Section from 'src/components/sections/Section/Section'
import { readCookie, setCookie } from 'src/utils/cookies'
import { useClickAway } from 'react-use'

const PopUpCookies = () => {
  const [showPopup, setShowPopup] = useState(false)
  const { pathname } = useLocation()
  const ref = useRef(null)

  const handleClosePopup = () => {
    setCookie('cookiePolicies', 'true', { expiresInMinutes: 365 * 24 * 60 })
    setShowPopup(false)
  }

  useClickAway(ref, () => {
    const appInstallElement = document?.getElementById('popup-install-app')

    if (appInstallElement) {
      return
    }

    setShowPopup(false)
  })

  useEffect(() => {
    if (!readCookie('cookiePolicies=true')) {
      setShowPopup(true)
    }
  }, [pathname])

  if (!showPopup) {
    return null
  }

  return (
    <Section className="bottom-20 md:bottom-6 md:left-10 popup-cookies fixed z-[998] pointer-events-none">
      <div ref={ref} className="px-4 pointer-events-none">
        <div className="max-w-md flex pl-[23px] pt-[9px] pb-[10px] pr-4 md:p-4 justify-center items-center bg-white rounded-round md:rounded-md pointer-events-auto md:max-w-[378px] shadow-[-1px_4px_20.6px_0_rgba(0,0,0,0.25)]">
          <div className="popup-cookies__text flex justify-center gap-4 items-center">
            <p className="text-font-size-1 md:text-sm font-medium md:pr-10">
              Nosso site usa cookies para melhorar sua navegação.{' '}
              <a
                target="_blank"
                href="https://www.decathlon.com.br/servicos/politica-de-privacidade/"
                rel="noreferrer"
                className="underline"
              >
                Política de privacidade
              </a>
            </p>
            <button
              className="text-sm w-36 px-4 py-2 bg-[#101010] hover:bg-restructure-background-action-1-hover text-white rounded-round"
              onClick={handleClosePopup}
            >
              Aceitar
            </button>
          </div>
        </div>
      </div>
    </Section>
  )
}

export default PopUpCookies
